"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Columns = _interopRequireDefault(require("@rsuite/icon-font/lib/layout/Columns"));

// Generated by script, don't edit it please.
var Columns = (0, _createSvgIcon["default"])({
  as: _Columns["default"],
  ariaLabel: 'columns',
  category: 'layout',
  displayName: 'Columns'
});
var _default = Columns;
exports["default"] = _default;
module.exports = exports.default;